<template>
    <div class="container">
        <div class="text">
            <h4>mOS=16.3 (8+8)個月</h4>
            <h3 class="title-caption">一路過88</h3>
            <h5>
                第一線不適合Cisplatin療法資格的病患,<br/>
                在接受<b>TECENTRIQ</b>治療後整體存活期中位數mOS達16.3個月<br/>
            </h5>
            <h3 class="last-text">
                上泌尿道, 高齡及ECOG 好的病患<br/>
                整題存活期中位數 <span class="caption">mOS 皆超過20 個月</span>
                <small style="color:#508fa8;">(IMvigor 210 Phase II, n=119)</small>
            </h3>
        </div><!-- text end sub -->
        <div class="flow-container">
            <a @click.prevent="flow1 = !flow1" href="#">
                <img v-if="flow1 === false" src="../../assets/step5/flow-1.png" alt="">
                <img v-if="flow1" src="../../assets/step5/flow-1-change.png" alt="">
            </a>
            <a @click.prevent="flow2 = !flow2" href="#">
                <img v-if="flow2 === false" src="../../assets/step5/flow-2.png" alt="">
                <img v-if="flow2" src="../../assets/step5/flow-2-change.png" alt="">
            </a>
            <a @click.prevent="flow3 = !flow3" href="#">
                <img v-if="flow3 === false" src="../../assets/step5/flow-3.png" alt="">
                <img v-if="flow3" src="../../assets/step5/flow-3-change.png" alt="">
            </a>
            <a @click.prevent="flow4 = !flow4" href="#">
                <img v-if="flow4 === false" src="../../assets/step5/flow-4.png" alt="">
                <img v-if="flow4" src="../../assets/step5/flow-4-change.png" alt="">
            </a>
        </div>
        <div class="footerText">
          2018 American Society of Clinical Oncology (Asco) June 1-5,2018, Chicago, IL, USA Abstract#4523
        </div>
        <template>
          <!-- <router-link to="/step4-2" class="btn-prev el-icon-arrow-left"></router-link> -->
          <router-link
          to="/step1" class="btn-next el-icon-arrow-right"></router-link>
        </template>
    </div>
</template>

<script>
export default {
  name: 'page1',
  data () {
    return {
      flow1: false,
      flow2: false,
      flow3: false,
      flow4: false
    }
  }
}
</script>

<style scoped>
  .text {text-align:center;}
  .text * {font-weight:normal;letter-spacing:.8pt;margin:0;}
  .text h4 {font-size:20px;margin:0;color:#c594a5;}
  .text h5,.text h3 {text-align:left;color:#5f5f5f;letter-spacing:1pt;}
  .text h5 {font-size:16px;line-height:26px;}
  .text .title-caption {font-size:30px;margin:10px 0;text-align:center;color:#ee7b0a;}
  .text .last-text {margin-top:10px;line-height:30px;}
  .text .last-text .caption {color:#64174f;font-weight:bold;}
  .text b {font-weight:bold;}
  .flow-container {font-size:0;margin:50px 0;}
  .flow-container a {
    display:inline-block;width:25%;
    vertical-align:top;
  }
  .flow-container a img {width:100%;}
  a[class*="btn-"]{
    background:#b6798e;color:white;
  }
  @media(max-width:750px){
      .container {width:90%;margin-left:5%;}
  }
</style>



// WEBPACK FOOTER //
// src/components/step5/page1.vue